import { getData } from '../../get-table'
import { HttpService } from '../../http.service'
import { reduceEmployees } from '../index'
import {
  ReportCostaRicaBankBcr,
  ReportDaviviendaBankCR,
  ReportSantanerBankUY,
  ReportRAPHN,
  ReportPrevisionSocialBankUY,
  ReportBankFormat17CR,
  ReportBankFormat11CR,
  ReportBankBacFormat06,
  ReportBankPromericaTxt,
  ReportBankLafiseTxt,
  ReportCitibankCR,
  ReportCCSS,
  ReportINS,
  ReportBCSINPE,
  ReportBNCR,
  ReportLafiseV3,
  ReportGeneralBank,
  ReportScotiabank,
  ReportISRHonduras,
  ReportCitibankUY,
  ReportLafiseV3HN,
  ReportPaylink,
  ReportIRPF,
  ReportBancomer232,
  ReportBancomer108,
  ReportBacSba
} from './types'
import { convertArrayToString } from '../index'
export * from './types'
const http = new HttpService()

export async function getClosedPayrolls(
  payrollIds: string,
  processesCode: string,
  startDate: string,
  endDate: string
) {
  const where = [
    `processed_payrolls.payroll_id IN (${payrollIds})`,
    `processed_payrolls.start_date>='${startDate}' AND processed_payrolls.end_date<='${endDate}'`,
    `payroll_status.code='CLOSED'`,
    `processes.code IN (${processesCode})`
  ]

  const data = await getData<any>({
    tables: ['pg_processed_payrolls'],
    fields: [
      'processed_payrolls.id',
      'processed_payrolls.payroll_id',
      'processes.code as process',
      'processed_payrolls.start_date',
      'processed_payrolls.end_date',
      'processed_payrolls.employees'
    ],
    join: [
      'INNER JOIN payroll_status ON processed_payrolls.payroll_status_id = payroll_status.id',
      'INNER JOIN processes ON processed_payrolls.process_id = processes.id'
    ],
    where,
    modifier: ['order by processed_payrolls.created_at desc']
  })

  let _employees: any = []
  for (const closedPayroll of data[0].results) {
    _employees = _employees.concat(...closedPayroll.employees)
  }

  return reduceEmployees(_employees)
}

export async function getBankId(
  codeReport: string,
  path?: string,
  report?: string
) {
  const where = [`code='${codeReport}'`]

  if (path !== '' && path !== undefined) {
    where.push(`path='${path}'`)
  }

  const data = await getData<any>({
    tables: ['pg_reports_config'],
    fields: ['bank_id'],
    where
  })
  if (report === 'LafiseHN') {
    return getBanksLafiseHN(data[0].results[0].bank_id)
  } else {
    return getBanks(data[0].results[0].bank_id)
  }
}

export async function getBankParentId(
  codeReport: string,
  path?: string,
  report?: string
): Promise<string> {
  const where = [`code='${codeReport}'`]

  if (path !== '' && path !== undefined) {
    where.push(`path='${path}'`)
  }

  const data = await getData<any>({
    tables: ['pg_reports_config'],
    fields: ['bank_id'],
    where
  })
  return data[0].results[0].bank_id
}

export async function getBanks(idBank: string) {
  const where = [`parent_bank_id='${idBank}'`]

  const data = await getData<any>({
    tables: ['pg_bank_codes'],
    fields: ['banks.id', 'banks.name'],
    join: ['INNER JOIN banks ON bank_codes.child_bank_id=banks.id'],
    where
  })

  return data[0].results
}

export async function getBanksLafiseHN(idBank: string) {
  const where = [`banks.id='${idBank}'`]

  const data = await getData<any>({
    tables: ['pg_bank_codes'],
    fields: ['banks.id', 'banks.name'],
    join: ['INNER JOIN banks ON bank_codes.child_bank_id=banks.id'],
    where
  })

  return data[0].results
}

export async function getCurrenciesId(codeReport: string, path?: string) {
  const where = [`code='${codeReport}'`]

  if (path !== '' && path !== undefined) {
    where.push(`path='${path}'`)
  }

  const data = await getData<any>({
    tables: ['pg_reports_config'],
    fields: ['currencies'],
    where
  })

  const strCurrencies = await convertArrayToString(
    data[0].results[0].currencies
  )

  return getCurrencies(strCurrencies)
}

export async function getCurrencies(ids: any = '') {
  const where = ['is_deleted = false']
  if (ids !== '') where.push(`id IN (${ids})`)
  const data = await getData<any>({
    tables: ['pg_currencies'],
    fields: ['id', "CONCAT(code,' - ',name) as name", 'code'],
    where,
    modifier: ['order by name asc']
  })

  return data[0].results
}

export async function getAccountTypes() {
  const data = await getData<any>({
    tables: ['pg_account_types'],
    fields: ['id', 'name', 'code']
  })

  return data[0].results
}

export async function getPaymentMethodByBankUY(companyId?: string) {
  const where = [
    `payment_methods.is_deleted = false AND payment_methods.company_id = '${companyId}' AND payment_methods.payment_type_id = '7d5d4077-5174-4e4b-b347-f81498b2a32c'`
  ]
  const data = await getData<any>({
    tables: ['pg_payment_methods'],
    fields: [
      "payment_methods.custom_fields->>'custom:bankAccount' as id",
      "concat(banks.name, ' - ', payment_methods.custom_fields->>'custom:bankAccount') as name"
    ],
    join: [
      "INNER JOIN banks ON (payment_methods.custom_fields->>'custom:bank')::varchar = banks.id::varchar"
    ],
    where
  })

  return data[0].results
}

export async function getDataCompany(idCompany: string) {
  const where = [`id='${idCompany}'`]
  const data = await getData<any>({
    tables: ['pg_companies'],
    fields: [
      'account_number',
      'policy',
      "custom_fields->>'custom:bankClientNumber' as bankClientNumber"
    ],
    where
  })

  data[0].results[0].bankClientNumber === null
    ? (data[0].results[0].bankClientNumber = '')
    : data[0].results[0].bankClientNumber

  return data[0].results[0]
}

export async function getEmployees(banksIds: string, employeesIds: string) {
  const where = [
    `banks.id IN (${banksIds})`,
    `employees.id IN (${employeesIds})`,
    'employee_accounts.is_active_account=true'
  ]

  const data = await getData<any>({
    tables: ['pg_employee_accounts'],
    fields: [
      'employees.id',
      'employees.name',
      'directions.name as direccion',
      'managements.name as gerencia',
      'departments.name as departamento',
      'sucursals.name as sucursal',
      'positions.name as cargo',
      'turns.name as turno',
      'employees.leave_date as fechaSalida',
      'employees.code as codigo',
      'joining_reasons.name as causaIngreso',
      "CONCAT(employees.code,' - ',employees.name) as codigo_name",
      "STRING_AGG(banks.id::text, ', ') as bankId",
      'false as isChecked'
    ],
    join: [
      'INNER JOIN employees ON employee_accounts.employee_id = employees.id',
      'INNER JOIN banks ON employee_accounts.bank_id = banks.id',
      'LEFT JOIN directions ON employees.direction_id = directions.id',
      'LEFT JOIN managements ON employees.management_id = managements.id',
      'LEFT JOIN departments ON employees.department_id = departments.id',
      'LEFT JOIN sucursals ON employees.sucursal_id = sucursals.id',
      'LEFT JOIN positions ON employees.position_id = positions.id',
      'LEFT JOIN turns ON employees.turn_id = turns.id',
      'LEFT JOIN joining_reasons ON employees.joining_reason_id = joining_reasons.id'
    ],
    where,
    modifier: [
      'group by employees.id,employees.name, employees.leave_date, employees.code,directions.name,managements.name,sucursals.name,departments.name,positions.name,turns.name,joining_reasons.name',
      'order by employees.name asc'
    ]
  })

  return data[0].results
}

export async function getEmployeesReport(
  payrollIds: string,
  conditions: string,
  employeesIds: string = ''
) {
  const where = ['employees.is_deleted=false']
  if (payrollIds !== '') where.push(`employees.payroll_id in (${payrollIds})`)
  if (employeesIds !== '') where.push(`employees.id in (${employeesIds})`)
  if (conditions !== '') where.push(conditions)

  const data = await getData<any>({
    tables: ['pg_employees'],
    fields: [
      'distinct employees.id',
      'employees.name',
      'directions.name as direccion',
      'managements.name as gerencia',
      'departments.name as departamento',
      'sucursals.name as sucursal',
      'positions.name as cargo',
      'turns.name as turno',
      'employees.leave_date as fechaSalida',
      'employees.code as codigo',
      'joining_reasons.name as causaIngreso',
      "CONCAT(employees.code,' - ',employees.name) as codigo_name",
      'false as isChecked'
    ],
    join: [
      'LEFT JOIN directions ON employees.direction_id = directions.id',
      'LEFT JOIN managements ON employees.management_id = managements.id',
      'LEFT JOIN departments ON employees.department_id = departments.id',
      'LEFT JOIN sucursals ON employees.sucursal_id = sucursals.id',
      'LEFT JOIN positions ON employees.position_id = positions.id',
      'LEFT JOIN turns ON employees.turn_id = turns.id',
      'LEFT JOIN joining_reasons ON employees.joining_reason_id = joining_reasons.id'
    ],
    where,
    modifier: ['order by employees.name asc']
  })

  return data[0].results
}

export async function getIdPaymentType(codePaymentType: string) {
  const where = [`code IN ('${codePaymentType}')`]

  const data = await getData<any>({
    tables: ['pg_salary_payment_types'],
    fields: ['distinct id'],
    where
  })
  return { idPaymentType: data[0].results[0].id }
}

export async function getSucursals(idCompany: string) {
  const where = [`company_id ='${idCompany}'`]

  const data = await getData<any>({
    tables: ['pg_sucursals'],
    fields: ['distinct id', 'name'],
    where
  })
  return data[0].results
}

export function getFormatFile(country: string) {
  const formatFile = new Map<string, any>([
    [
      'UY',
      [
        { id: 493, name: '493 - Manager check' },
        { id: 494, name: '494 - Manager check (USD)' },
        { id: 440, name: '440 - Book transfer' },
        { id: 441, name: '441 - Domestic funds transfer' },
        { id: 442, name: '442 - Crossborder funds transfer' }
      ]
    ],
    [
      'CR',
      [
        { id: 440, name: '440 - Book transfer' },
        { id: 441, name: '441 - Domestic funds transfer' }
      ]
    ]
  ])

  return formatFile.get(country)
}

export async function getAccountTypesByCountry(countryId?: string) {
  const where = [
    `'${countryId}' IN (SELECT jsonb_array_elements_text(countries))`
  ]
  const data = await getData<any>({
    tables: ['pg_account_types'],
    fields: ['id', 'name', 'code'],
    where
  })

  return data[0].results
}

export async function generateCostaRicaBankBcr(
  data: ReportCostaRicaBankBcr
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      banks: data.parameters.banks,
      paymentBases: data.parameters.paymentBases,
      accountTypes: data.parameters.accountTypes,
      fileData: {
        currency: data.parameters.fileData.currency,
        beneficiaryNumber: data.parameters.fileData.beneficiaryNumber,
        deliveryNumber: data.parameters.fileData.deliveryNumber,
        detail: data.parameters.fileData.detail,
        referenceOne: data.parameters.fileData.referenceOne,

        executionDate: data.parameters.fileData.executionDate
      },
      employees: data.parameters.employees,
      modifiers: {
        identificationFormat: data.parameters.modifiers.identificationFormat
      }
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateDaviviendaBankCR(
  data: ReportDaviviendaBankCR
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      banks: data.parameters.banks,
      detail: data.parameters.detail,
      notification: data.parameters.notification,
      conciliation: data.parameters.conciliation,
      endDate: data.parameters.endDate,
      paymentBases: data.parameters.paymentBases,
      accountTypes: data.parameters.accountTypes,
      paymentType: data.parameters.paymentType,
      format: data.parameters.format,
      employees: data.parameters.employees
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateSantanderBankUY(
  data: ReportSantanerBankUY
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      banks: data.parameters.banks,
      currency: data.parameters.currency,
      accountNumberCompany: data.parameters.accountNumberCompany,
      accountTypes: data.parameters.accountTypes,
      paymentDate: data.parameters.paymentDate,
      // accountsFormat: data.parameters.accountsFormat,
      // identificationFormat: data.parameters.identificationFormat,
      employees: data.parameters.employees
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateRAPHN(data: ReportRAPHN): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      processes: data.parameters.processes,
      concepts: data.parameters.concepts,
      month: data.parameters.month,
      year: data.parameters.year,
      subsidiaries: data.parameters.subsidiaries,
      fileType: data.parameters.fileType,
      format: data.parameters.format,
      identificationFormat: data.parameters.identificationFormat
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generatePrevisionSocialBankUY(
  data: ReportPrevisionSocialBankUY
): Promise<string> {
  const parameters: any = {
    payrolls: data.parameters.payrolls,
    processes: data.parameters.processes,
    conceptsQuantityHours: data.parameters.conceptsQuantityHours,
    month: data.parameters.month,
    year: data.parameters.year,
    modifiers: data.parameters.modifiers,
    employees: data.parameters.employees
  }
  if (data.parameters.format) parameters.format = data.parameters.format

  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: parameters
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }

  return response?.data
}

export async function generateBankFormat11CR(
  data: ReportBankFormat11CR
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      paymentBases: data.parameters.paymentBases,
      accountTypes: data.parameters.accountTypes,
      fileData: {
        deliveryNumber: data.parameters.fileData.deliveryNumber,
        companyNumber: data.parameters.fileData.companyNumber,
        transactionDate: data.parameters.fileData.transactionDate,
        paymentDescription: data.parameters.fileData.paymentDescription
      },
      modifiers: {
        identificationFormat: data.parameters.modifiers.identificationFormat
      },
      employees: data.parameters.employees
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }

  return response?.data
}

export async function generateBankFormat17CR(
  data: ReportBankFormat17CR
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      banks: data.parameters.banks,
      paymentBases: data.parameters.paymentBases,
      accountTypes: data.parameters.accountTypes,
      fileData: {
        planNumber: data.parameters.fileData.planNumber,
        deliveryNumber: data.parameters.fileData.deliveryNumber,
        companyAccountNumber: data.parameters.fileData.companyAccountNumber,
        transactionDate: data.parameters.fileData.transactionDate,
        paymentDescription: data.parameters.fileData.paymentDescription,
        companyReference: data.parameters.fileData.companyReference
      },
      employees: data.parameters.employees,
      modifiers: {
        identificationFormat: data.parameters.modifiers.identificationFormat
      }
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateBankFormat06(
  data: ReportBankBacFormat06
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      banks: data.parameters.banks,
      paymentBases: data.parameters.paymentBases,
      accountTypes: data.parameters.accountTypes,
      fileData: {
        planNumber: data.parameters.fileData.planNumber,
        deliveryNumber: data.parameters.fileData.deliveryNumber,
        transactionDate: data.parameters.fileData.transactionDate,
        paymentDescription: data.parameters.fileData.paymentDescription
      },
      employees: data.parameters.employees,
      modifiers: {
        identificationFormat: data.parameters.modifiers.identificationFormat
      }
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateLafiseTxt(
  data: ReportBankLafiseTxt
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      banks: data.parameters.banks,
      paymentBases: data.parameters.paymentBases,
      accountTypes: data.parameters.accountTypes,
      fileData: {
        paymentDescription: data.parameters.fileData.paymentDescription
      },
      employees: data.parameters.employees,
      modifiers: {
        identificationFormat: data.parameters.modifiers.identificationFormat
      }
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generatePromericaTxt(
  data: ReportBankPromericaTxt
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      banks: data.parameters.banks,
      paymentBases: data.parameters.paymentBases,
      accountTypes: data.parameters.accountTypes,
      employees: data.parameters.employees,
      currencies: data.parameters.currencies,
      fileData: data.parameters.fileData
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateCitibankCR(
  data: ReportCitibankCR
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      banks: data.parameters.banks,
      paymentBases: data.parameters.paymentBases,
      accountTypes: data.parameters.accountTypes,
      fileData: {
        currency: data.parameters.fileData.currency,
        paymentType: data.parameters.fileData.paymentType,
        beneficiaryNumber: data.parameters.fileData.beneficiaryNumber,
        companyAccountNumber: data.parameters.fileData.companyAccountNumber,
        transactionDate: data.parameters.fileData.transactionDate,
        paymentDescription: data.parameters.fileData.paymentDescription,
        reference1: data.parameters.fileData.reference1,
        reference2: data.parameters.fileData.reference2
      },
      employees: data.parameters.employees,
      modifiers: {
        identificationFormat: data.parameters.modifiers.identificationFormat
      }
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateCCSS(data: ReportCCSS): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      processes: data.parameters.processes,
      conceptsAmount: data.parameters.conceptsAmount,
      conceptsQuantityHours: data.parameters.conceptsQuantityHours,
      conceptsMaternity: data.parameters.conceptsMaternity,
      month: data.parameters.month,
      year: data.parameters.year,
      employees: data.parameters.employees,
      format: data.parameters.format,
      modifiers: {
        identificationFormat: data.parameters.modifiers.identificationFormat
      }
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateINS(data: ReportINS): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      processes: data.parameters.processes,
      conceptsAmount: data.parameters.conceptsAmount,
      conceptsQuantityHours: data.parameters.conceptsQuantityHours,
      month: data.parameters.month,
      year: data.parameters.year,
      employees: data.parameters.employees,
      modifiers: {
        policyNumber: data.parameters.modifiers.policyNumber,
        conceptsSchoolSalary: data.parameters.modifiers.conceptsSchoolSalary,
        identificationFormat: data.parameters.modifiers.identificationFormat
      },
      format: data.parameters.format
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateBCRSINPE(data: ReportBCSINPE): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      concepts: data.parameters.concepts,
      employees: data.parameters.employees,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      banks: data.parameters.banks,
      paymentBases: data.parameters.paymentBases,
      accountTypes: data.parameters.accountTypes,
      applicationDate: data.parameters.applicationDate,
      currencyId: data.parameters.currencyId,
      clientIdentification: data.parameters.clientIdentification,
      transferNumber: data.parameters.transferNumber,
      voucherNumber: data.parameters.voucherNumber,
      debitDetail: data.parameters.debitDetail,
      companyAccount: data.parameters.companyAccount,
      identificationFormat: data.parameters.identificationFormat
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateBNCR(data: ReportBNCR): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      concepts: data.parameters.concepts,
      employees: data.parameters.employees,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      paymentBases: data.parameters.paymentBases,
      accountTypes: data.parameters.accountTypes,
      applicationDate: data.parameters.applicationDate,
      currencyId: data.parameters.currencyId,
      clientIdentification: data.parameters.clientIdentification,
      transferNumber: data.parameters.transferNumber,
      voucherNumber: data.parameters.voucherNumber,
      debitDetail: data.parameters.debitDetail,
      companyAccount: data.parameters.companyAccount,
      exchangeRatePurchase: data.parameters.exchangeRatePurchase,
      exchangeRateSale: data.parameters.exchangeRateSale
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateLafiseV3(data: ReportLafiseV3): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      banks: data.parameters.banks,
      currency: data.parameters.currency,
      billingNumber: data.parameters.billingNumber,
      paymentDate: data.parameters.paymentDate,
      billingDate: data.parameters.billingDate,
      reference: data.parameters.reference,
      paymentBases: data.parameters.paymentBases,
      accountTypes: data.parameters.accountTypes,
      employees: data.parameters.employees
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateGeneralBank(
  data: ReportGeneralBank
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      banks: data.parameters.banks,
      currency: data.parameters.currency,
      detail: data.parameters.detail,
      paymentBases: data.parameters.paymentBases,
      accountTypes: data.parameters.accountTypes,
      executionDate: data.parameters.executionDate,
      identificationFormat: data.parameters.identificationFormat,
      employees: data.parameters.employees
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateScotiabank(
  data: ReportScotiabank
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      banks: data.parameters.banks,
      currencyId: data.parameters.currencyId,
      detail: data.parameters.detail,
      paymentBases: data.parameters.paymentBases,
      accountTypes: data.parameters.accountTypes,
      employees: data.parameters.employees,
      format: data.parameters.format
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateISRHonduras(
  data: ReportISRHonduras
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      processes: data.parameters.processes,
      retentionConcepts: data.parameters.retentionConcepts,
      incomeTaxConcepts: data.parameters.incomeTaxConcepts,
      period: data.parameters.period,
      year: data.parameters.year,
      identificationFormat: data.parameters.identificationFormat
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateCitibankUY(
  data: ReportCitibankUY
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      banks: data.parameters.banks,
      currency: data.parameters.currency,
      detail: data.parameters.detail,
      reference: data.parameters.reference,
      formatFile: data.parameters.formatFile,
      accountNumberCompany: data.parameters.accountNumberCompany,
      paymentDate: data.parameters.paymentDate,
      employees: data.parameters.employees
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateBacSba(data: ReportBacSba): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      employees: data.parameters.employees,
      concepts: data.parameters.concepts,

      currencyId: data.parameters.currencyId,
      banks: data.parameters.banks,
      paymentBases: data.parameters.paymentBases,
      accountTypes: data.parameters.accountTypes,

      reference: data.parameters.reference,
      bic: data.parameters.bic,
      trackingNumber: data.parameters.trackingNumber,
      paymentMethod: data.parameters.paymentMethod,
      priorityCode: data.parameters.priorityCode,
      categoryPurposeCode: data.parameters.categoryPurposeCode || '',
      paymentDate: data.parameters.paymentDate,
      debtorAccountNumber: data.parameters.debtorAccountNumber,
      propietaryScheme: data.parameters.propietaryScheme || '',
      originClientBic: data.parameters.originClientBic,
      expirationDate: data.parameters.expirationDate,
      destinationClientBic: data.parameters.destinationClientBic,
      beneficiaryId: data.parameters.beneficiaryId,
      privateReference: data.parameters.privateReference,
      paymentDescription: data.parameters.paymentDescription
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateLafiseV3HN(
  data: ReportLafiseV3HN
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      currency: data.parameters.currency,
      description: data.parameters.description,
      paymentBases: data.parameters.paymentBases,
      accountTypes: data.parameters.accountTypes,
      employees: data.parameters.employees
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}
export async function generatePaylinkCR(data: ReportPaylink): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      banks: data.parameters.banks,
      currency: data.parameters.currency,
      accountNumberCompany: data.parameters.accountNumberCompany,
      accountNumberIBAN: data.parameters?.accountNumberIBAN ?? '',
      reference: data.parameters.reference,
      description: data.parameters.description,
      paymentDate: data.parameters.paymentDate,
      paymentBases: data.parameters.paymentBases,
      accountTypes: data.parameters.accountTypes,
      identificationFormat: data.parameters.identificationFormat,
      employees: data.parameters.employees,
      includeVOI: data.parameters.includeVOI,
      batchReference: data.parameters.batchReference,
      localTransactionType: data.parameters.localTransactionType
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generatePaylinkHN(data: ReportPaylink): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      banks: data.parameters.banks,
      currency: data.parameters.currency,
      accountNumberCompany: data.parameters.accountNumberCompany,
      reference: data.parameters.reference,
      description: data.parameters.description,
      paymentDate: data.parameters.paymentDate,
      paymentBases: data.parameters.paymentBases,
      accountTypes: data.parameters.accountTypes,
      identificationFormat: data.parameters.identificationFormat,
      employees: data.parameters.employees,
      includeVOI: data.parameters.includeVOI
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateIRPF(data: ReportIRPF): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payroll,
      employees: data.parameters.employees,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      taxedTotals: data.parameters.taxedTotals,
      proportionalDeductions: data.parameters.proportionalDeductions,
      withHoldingsIRPF: data.parameters.withholdingsIRPF,
      bonuses: data.parameters.bonuses,
      vacationSalary: data.parameters.vacationSalary,
      format: data.parameters.format
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}
export async function generateBancomer108(
  data: ReportBancomer108
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      banks: data.parameters.banks,
      currency: data.parameters.currency,
      paymentBases: data.parameters.paymentBases,
      accountTypes: data.parameters.accountTypes,
      employees: data.parameters.employees,
      reportType: data.parameters.reportType
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export function getServiceType(country: string) {
  const formatFile = new Map<string, any>([
    [
      'MX',
      [
        { id: 101, name: '101 - Nomina Tradicional' },
        { id: 110, name: '110 - Tarjet de Pagos' }
      ]
    ]
  ])

  return formatFile.get(country)
}

export function getCaptionCode(serviceType: string) {
  const formatFile = new Map<string, any>([
    [
      '101',
      [
        { id: 'R05', name: 'R05 - Pago de Nómina' },
        { id: 'R10', name: 'R10 - Pago Pensiones' },
        { id: 'R16', name: 'R16 - Pago de Aguinaldo' },
        { id: 'R17', name: 'R17 - Pago de Pensión' },
        { id: 'R18', name: 'R18 - Pago de Bono' },
        { id: 'R19', name: 'R19 - Pago Prima Vacacional' },
        { id: 'R20', name: 'R20 - Pago de Tiempo Extra' },
        { id: 'R21', name: 'R21 - Pago Fondo de Ahorro' },
        { id: 'R22', name: 'R22 - Pago de Utilidades' },
        { id: 'R23', name: 'R23 - Pago de Nómina + Motivo de Pago' },
        { id: 'R33', name: 'R33 - Pago de Comisionistas' },
        { id: 'R45', name: 'R45 - Pago Caja de Ahorro' },
        { id: 'R46', name: 'R46 - Pago Becas' },
        { id: 'R47', name: 'R47 - Pago Viáticos' }
      ]
    ],
    ['110', [{ id: 'R05', name: 'R05 - Pago Electrónico' }]]
  ])

  return formatFile.get(serviceType)
}

export async function generateBancomer232(
  data: ReportBancomer232
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      paymentDate: data.parameters.paymentDate,
      concepts: data.parameters.concepts,
      banks: data.parameters.banks,
      currency: data.parameters.currency,
      paymentBases: data.parameters.paymentBases,
      accountTypes: data.parameters.accountTypes,
      serviceType: data.parameters.serviceType,
      captionCode: data.parameters.captionCode,
      numericReference: data.parameters.numericReference,
      paymentReason: data.parameters.paymentReason,
      identificationFormat: data.parameters.identificationFormat,
      employees: data.parameters.employees,
      paymentMethod: data.parameters.paymentMethod,
      reportType: data.parameters.reportType
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function getPaymentMethod(companyId?: string) {
  const where = [
    `payment_methods.is_deleted = false AND payment_methods.company_id = '${companyId}' AND payment_methods.currency_id = '0ea64e19-642c-4974-9243-362c9a5615f6' AND payment_methods.payment_type_id = '7d5d4077-5174-4e4b-b347-f81498b2a32c'
    AND banks.id = '745c573c-2842-49c2-9e41-a4e0904dc4f3'`
  ]
  const data = await getData<any>({
    tables: ['pg_payment_methods'],
    fields: [
      'payment_methods.id',
      "concat(banks.name, ' - ', payment_methods.custom_fields->>'custom:bankNumberClient') as name"
    ],
    join: [
      "INNER JOIN banks ON (payment_methods.custom_fields->>'custom:bank')::varchar = banks.id::varchar"
    ],
    where
  })

  return data[0].results
}
